import * as React from "react";
import { inject, observer } from "mobx-react";
import { MobxComponent } from "../../../../mobx/components";
import { UI } from "../../../../core/ui";
import { Untrusive } from "@lib/common";
import { AuthLayout } from "../layout";
import {
	AuthHeading,
	AuthIntro,
	AuthSubheading,
	FormField,
	FormInput,
	FormLabel,
	FormStack,
	SubmitButton,
} from "./login.form.c";

interface Props { }
interface State {
	name: string;
	loading: boolean;
}

@inject("store") @observer
export class AuthSSO extends MobxComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			name: "",
			loading: false,
		};
	}

	submit = async (e: any) => {
		e.preventDefault();
		try {

			const { router } = this.injected.store;
			const { name } = this.state;

			if (!name) {
				UI.notification.error("Please enter a display name");
				return;
			}

			const { returnUrl } = router.s.query;

			this.setState({ loading: true });
			window.location.href = `https://cloudwaitress.nolt.io/${""}?returnUrl=${returnUrl}`;

		}
		catch (e) {
			Untrusive.stop();
			this.setState({ loading: false });
			UI.notification.error("Something went wrong, try again or contact us");
		}
	}

	render() {
		const { loading } = this.state;
		return (
			<AuthLayout loading={loading}>
				<AuthIntro>
					<AuthHeading>Login To External Application</AuthHeading>
					<AuthSubheading>Enter a display name to continue.</AuthSubheading>
				</AuthIntro>
				<form onSubmit={this.submit}>
					<FormStack>
						<FormField>
							<FormLabel htmlFor="display-name">Display Name</FormLabel>
							<FormInput
								id="display-name"
								type="text"
								placeholder="Display Name"
								required={true}
								value={this.state.name}
								onChange={(e) => this.setState({ name: e.target.value })}
								disabled={loading}
							/>
						</FormField>
						<SubmitButton type="submit" disabled={loading}>
							Proceed
						</SubmitButton>
					</FormStack>
				</form>
			</AuthLayout>
		);
	}

}
